export const title = 'Clickpost Alert';

export const meta = [
  {
    charset: 'UTF-8'
  },
  {
    name: 'viewport',
    content: 'width=device-width, initial-scale=1, shrink-to-fit=no'
  },
  {
    httpEquiv: 'X-UA-Compatible',
    content: 'IE=edge'
  },
  {
    name: 'description',
    content: 'Clickpost alerting system'
  },
  {
    name: 'theme-color',
    content: '#00D1E8'
  }
];

export const link = [
  {
    rel: 'shortcut icon',
    href: `${process.env.PUBLIC_URL}/favicon.ico?v1`
  }
];

export const script = [];

export const noscript = [];
